import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { SdfIcon } from '@waypoint/react-components';
import { getCallingAppId } from '../../util/misc/common';

function NativeBanner({ platform, onClose }) {
  const productId = getCallingAppId();

  const handleOpenApp = () => {
    const isAndroid = /Android/.test(navigator.userAgent);
    const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);

    try {
      if (isAndroid) {
        const fullUrl = `https://static.adp.com/static/redbox/qr-code-redirect.html?campaignID=NexoOLPBanner-${productId}`;
        window.open(fullUrl, '_blank');
      } else if (isIOS) {
        const fullUrl = `https://static.adp.com/static/redbox/qr-code-redirect.html?campaignID=NexoOLPBanner-${productId}`;
        window.open(fullUrl, '_blank');
      }
      onClose();
    } catch (error) {
      console.log('Error opening store:', error);
    }
  };

  return (
    <>
      { /* Add top padding to body when banner is shown */ }
      <style>{ 'body { padding-top: 70px !important; }' }</style>

      <div
        id="custom-mobile-banner"
        style={ {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          backgroundColor: '#000000',
          borderBottom: '1px solid #333333',
          padding: '12px 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          zIndex: 10000,
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
          fontSize: '14px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
        } }
      >
        <div
          style={ {
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            flexShrink: 1,
          } }
        >
          <div
            style={ {
              backgroundColor: '#E1261C',
              borderRadius: '10px',
              width: '50px',
              height: '50px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            } }
          >
            <SdfIcon
              slot="graphic"
              icon="brand-adp"
              shape="square"
              class="text-4xl"
              style={ {
                color: '#FFFFFF',
                fill: '#FFFFFF',
                width: '30px',
                height: '30px',
              } }
            />
          </div>

          { /* Platform-specific content - now with automatic translation access */ }
          { platform === 'ios' ? (
            <div
              style={ {
                display: 'flex',
                flexDirection: 'column',
                lineHeight: 1.2,
              } }
            >
              <div
                style={ { fontWeight: 600, color: '#FFFFFF', fontSize: '16px' } }
              >
                <FormattedMessage
                  id="smartbanner.headline.line3"
                  defaultMessage="ADP Mobile Solutions"
                />
              </div>
              <div style={ { color: '#CCCCCC', fontSize: '12px' } }>
                <FormattedMessage
                  id="smartbanner.headline.line4"
                  defaultMessage="HR for Employees and Managers"
                />
              </div>
            </div>
          ) : (
            <div
              style={ {
                display: 'flex',
                flexDirection: 'column',
                lineHeight: 1.2,
                maxWidth: '220px',
              } }
            >
              <div
                style={ {
                  fontWeight: 600,
                  color: '#F1F1F1',
                  fontSize: '14px',
                  letterSpacing: '0.1px',
                } }
              >
                <FormattedMessage
                  id="smartbanner.headline.line5"
                  defaultMessage="Download the ADP Mobile Solutions from Google Play"
                />
              </div>
            </div>
          ) }
        </div>

        <div
          style={ {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            flexShrink: 0,
          } }
        >
          <button
            type="button"
            onClick={ handleOpenApp }
            style={ {
              background: '#007AFF',
              color: 'white',
              border: 'none',
              padding: platform === 'android' ? '6px 20px' : '6px 24px',
              borderRadius: '999px',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
              minWidth: platform === 'android' ? '64px' : '70px',
            } }
          >
            <FormattedMessage
              id={
                platform === 'android'
                  ? 'smartbanner.headline.line7'
                  : 'smartbanner.headline.line6'
              }
              defaultMessage={ platform === 'android' ? 'Visit' : 'GET' }
            />
          </button>

          <button
            type="button"
            onClick={ onClose }
            style={ {
              background: 'none',
              border: 'none',
              fontSize: '18px',
              color: '#FFFFFF',
              cursor: 'pointer',
              padding: '4px',
              lineHeight: 1,
            } }
          >
            ×
          </button>
        </div>
      </div>
    </>
  );
}

NativeBanner.propTypes = {
  platform: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default NativeBanner;
